export default __webpack_public_path__ + "static/media/markus.72177b73.png";